import { AuthenticationService } from './../../../../../services/authentication.service';
import { InteractivityWidgetSelectionService } from '../../services/interactivity-widget-selection.service';
import { InteractivityWidgetDefinitionService } from '../../services/interactivity-widget-definition.service';
import { ReduxService } from '../../../../../services/redux.service';
import { InteractivityEditorService } from '../../services/interactivity-editor.service';
import { InteractivityWidgetService } from '../../services/interactivity-widget.service';
import { Component, ChangeDetectorRef, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IWidgetDefinition } from './../../interfaces/IWidgetDefinition';
import { TimelineDataActions } from '../../redux/timeline-data-actions';
import { WidgetType } from '../../enums/WidgetType';

@Component({
	selector: 'widget-bar',
	templateUrl: './widget-bar.component.html',
	styleUrls: ['./widget-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class WidgetBarComponent implements OnInit, OnDestroy {
	widgetDefinitions: IWidgetDefinition[];
	stageWidgetDefinitions: IWidgetDefinition[];
	rootPermission = false;
	subscriptions = new Subscription();

	constructor(
		public editorService: InteractivityEditorService,
		private interactiveWidgetSelectionService: InteractivityWidgetSelectionService,
		private interactiveWidgetDefinitionService: InteractivityWidgetDefinitionService,
		private interactiveWidgetService: InteractivityWidgetService,
		private reduxService: ReduxService,
		private authenticationService: AuthenticationService,
		private changeDetector: ChangeDetectorRef
	) {
		this.subscriptions.add(this.authenticationService.hasPermission('root').subscribe((hasRight: boolean) => this.rootPermission = hasRight));
	}

	ngOnInit() {
		this.subscriptions.add(this.interactiveWidgetDefinitionService.widgetDefinitionsSubject.subscribe((widgetDefinitions) => {
			this.widgetDefinitions = widgetDefinitions;
			this.stageWidgetDefinitions = this.widgetDefinitions.filter(
				(widget) => ['rectangle', 'image', 'button', 'video', 'textLabel', 'app', 'formTextField', 'formTextArea', 'formSelect', 'custom']
					.indexOf(widget.widgetDefinitionType) !== -1
			);

			// widget order in interface (run by Nico: 9 dec 2019)
			const widgetOrder = ['chapter',
				'action_only',
				'audio',
				'timer',
				'image',
				'button',
				'video',
				'textLabel',
				'formTextField',
				'rectangle',
				'formTextArea',
				'formSelect',
				'custom',
				'app'];
			this.stageWidgetDefinitions.sort((a, b) => {
				const iA: number = widgetOrder.indexOf(a.widgetDefinitionType);
				const iB: number = widgetOrder.indexOf(b.widgetDefinitionType);
				if (iA > iB) {
					return 1;
				} else if (iA < iB) {
					return -1;
				} else {
					return 0;
				}
			});

			this.changeDetector.detectChanges();
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	createNewWidget(type: WidgetType): void {
		if (type) {
			this.interactiveWidgetService.createWidget(type);
		}
	}

	deleteWidgets(): void {
		const ids: string[] = this.interactiveWidgetSelectionService.selectedWidgetIds;
		if (ids.length === 0) {
			return;
		}

		this.reduxService.dispatch({
			type: TimelineDataActions.REMOVE_WIDGETS,
			ids,
			description: 'Delete widget'
		});

		this.interactiveWidgetSelectionService.clearSelectedWidgets();
	}
}
